<template>
  <v-app>
    <main-header></main-header>

    <v-content>
      <router-view></router-view>
    </v-content>

    <float-alert :value="lastRequestError" color="red">
      {{ lastRequestError }}
    </float-alert>
    <float-alert :value="lastRequestSuccess" color="green">
      {{ lastRequestSuccess }}
    </float-alert>

    <v-snackbar :value="helpMessage" :timeout="helpTimeout" color="blue">
      <v-icon color="white" left>mdi-information</v-icon>
      {{ helpMessage }}
      <v-btn color="red" icon small @click="$store.dispatch('hiddeHelp')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="red"
      ></v-progress-linear>
  </v-app>
</template>

<script>
import { http } from './store/mapActions'
import FloatAlert from './components/FloatAlert'
import MainHeader from './components/MainHeader';
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState([
      'lastRequestError',
      'lastRequestSuccess',
      'loading',
      'helpTimeout',
      'helpMessage'
    ])
  },
  beforeCreate() {
    http.interceptors.request.use(
      config => this.$store.dispatch('startRequest') && config,
      error => this.$store.dispatch('connectionStatusChange', { ok: false, error}) && Promise.reject(error)
    )

    http.interceptors.response.use(
      response => this.$store.dispatch('endRequest', response.data) && response,
      error => this.$store.dispatch('endRequest', error.response.data) && Promise.reject(error)
    );
  },
  components: {
    MainHeader,
    FloatAlert
  }
}
</script>

<style>
@import url(./css/app.css);

main {
  overflow: hidden;
}
</style>